/*
  E5/AP-1: B2B-Checkout-Gate (§14 BGB).
  Wird auf der Warenkorb-Seite (main-cart-footer) UND im Cart-Drawer verwendet.
  Custom Element re-initialisiert sich auch nach Dawns AJAX-Re-Render (connectedCallback).
  Selektiert den Checkout-Button universell via [name="checkout"] (#checkout bzw. #CartDrawer-Checkout)
  und versteckt etwaige Express-/Dynamic-Checkout-Buttons, solange die Checkbox nicht gesetzt ist.
  Kein localStorage – State gilt nur fuer die aktuelle Seite/den aktuellen Drawer.
*/
(function () {
  if (customElements.get('b2b-gate')) return;

  class B2bGate extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.cart__b2b-checkbox');
      this.scope = this.closest('#main-cart-footer, .drawer__footer') || document;
      if (!this.checkbox) return;
      this.checkbox.addEventListener('change', this.update.bind(this));
      this.update();
    }

    update() {
      var ok = this.checkbox.checked;

      /* C4: Sobald bestätigt, Hinweis + Attention-Zustand zurücksetzen */
      if (ok) {
        var hint = this.scope.querySelector('.cart__b2b-hint');
        if (hint) hint.classList.remove('cart__b2b-hint--visible');
        this.classList.remove('cart__b2b-gate--attention');
      }

      this.scope.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
        btn.disabled = !ok;
        btn.classList.toggle('cart__checkout-button--gated', !ok);
      });

      this.scope
        .querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, .shopify-payment-button')
        .forEach(function (el) {
          // DE-F13b: sichtbar aber ausgegraut (Klasse) + non-interaktiv inkl. Tastatur/Fokus (inert).
          // ok=true -> beide entfernt -> Button voll funktionsfaehig.
          el.classList.toggle('b2b-gate-disabled', !ok);
          el.toggleAttribute('inert', !ok);
        });
    }
  }

  customElements.define('b2b-gate', B2bGate);

  /* C4: Klick auf gesperrten Checkout-Bereich -> zur Checkbox lenken.
     Der gesperrte Button hat pointer-events:none, der Klick landet daher auf
     .cart__ctas. Delegation auf document (einmalig) uebersteht Dawns AJAX-Re-Render. */
  document.addEventListener('click', function (e) {
    var ctas = e.target.closest ? e.target.closest('.cart__ctas') : null;
    if (!ctas) return;
    var scope = ctas.closest('#main-cart-footer, .drawer__footer') || document;
    var gate = scope.querySelector('.cart__b2b-gate');
    var checkbox = gate && gate.querySelector('.cart__b2b-checkbox');
    if (!gate || !checkbox || checkbox.checked) return;

    gate.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var hint = scope.querySelector('.cart__b2b-hint');
    if (hint) hint.classList.add('cart__b2b-hint--visible');
    /* Animation neu triggern (Reflow-Trick), danach Klasse wieder entfernen */
    gate.classList.remove('cart__b2b-gate--attention');
    void gate.offsetWidth;
    gate.classList.add('cart__b2b-gate--attention');
    setTimeout(function () { gate.classList.remove('cart__b2b-gate--attention'); }, 900);
  });
})();
